import React, {useState, useEffect} from 'react';
import {utils} from '../../../../global/js/utils.js';
import * as dataLayer from '../../../../global/js/dataLayer';
import _ from 'lodash';
import queryString from '../../../../global/js/query-string';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from 'react-places-autocomplete';

const AddressSearchBar = (props) => {
	const [searchTerm, setSearchTerm] = useState('');
	const [activeInput, setActiveInput] = useState('');
	const [loaded, setLoaded]= useState(false);
	const _queryStr = props.queryToUpdate || 'address';
	const [prevSuggestions, setPrevSuggestions] = useState([]);
	const [canClear, setCanClear] = useState(false);

	useEffect(() => {
		if(props.useCurrentLocation === true) {
			if(props.getAddress === undefined || props.getAddress === '') {
				currentLocation();
			}
		}
	}, []);

	// useEffect(()=>{
		// _.debounce(() => {
		// 	if(!!searchTerm) onSelect(searchTerm);
		// }, 150)
	// }, [searchTerm]);

	const currentLocation = () => {
		if (navigator.geolocation) {
			// eslint-disable-next-line no-undef
			let geocoder = new google.maps.Geocoder;
			navigator.geolocation.getCurrentPosition((position) => {
				const {latitude, longitude} = position.coords;
				geocodeLatLng(geocoder, {lat: latitude, lng: longitude});
			});
		} else {
			console.err('Geolocation is not supported by this browser.');
		}
	};

	const geocodeLatLng = (geocoder, latlng) => {
		geocoder.geocode({'location': latlng}, function(results, status) {
			if (status === 'OK') {
				if (results[0]) {
					setSearchTerm(results[0].formatted_address);
					props.onSelect(results[0].formatted_address);
					// window.history.replaceState('', '', utils.updateURLParameter(window.location.href, _queryStr, results[0].formatted_address));
					const _location = queryString.parse(localStorage.getItem('userLocation')) || {};
					_location[_queryStr] = results[0].formatted_address;
					_location['lat'] = latlng.lat;
					_location['lng'] = latlng.lng;
					localStorage.setItem('userLocation', $.param(_location));
				} else {
					return;
				}
			} else {
				console.log('Geocoder failed due to: ' + status);
			}
		});
	};

	useEffect(() => {
		if(props.getAddress) {
			setSearchTerm(props.getAddress);
			setCanClear(true);
		}
	}, [props.getAddress]);


	const onSelect = (address) =>{
		if(prevSuggestions.length < 1 || address.length <= 10) {
			return;
		}

		if(address.includes('Australia') === false && address.includes('New Zealand') === false) {
			return;
		}
		// the following is an effort to work around the hard coded URL F-UP string and to allow the parent a back door to handle the update itself
		if(props.onSelect) {
			props.onSelect(address);
		}
		handleSelect(address);

		// apply GTM datalayer search
		const parsedQuery = queryString.parse(location.search);
		const arrivalDate = parsedQuery.entry;
		const departureDate = parsedQuery.exit;
		dataLayer.pushCarparkSearch(arrivalDate, departureDate, address);
	};

	// refactor the shouldNotUpdateAddress out
	const handleSelect = (address, shouldNotUpdateAddress) => {
		setSearchTerm(address);

		// OMG 😕 WHY HARD CODE THE ADDRESS ON A GENERIC COMPONENT!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
		// window.history.replaceState('', '', utils.updateURLParameter(window.location.href, _queryStr, address));
		let _latLng;
		geocodeByAddress(address)
			.then((results) => getLatLng(results[0]))
			.then((latLng) => {
				console.log('Success', latLng);
				_latLng = latLng;
				// window.history.replaceState('', '', utils.updateURLParameter(window.location.href, 'lat', latLng.lat));
				// window.history.replaceState('', '', utils.updateURLParameter(window.location.href, 'lng', latLng.lng));

				if(props.setUserLocation) props.setUserLocation(latLng);
				// if (!props.preventFetchingResults) {
				if(props.fetchParkings) {
					props.fetchParkings(latLng);
				}

				if(props.fetchRecommendedParkings) {
					props.fetchRecommendedParkings(latLng);
				}
				// }
			})
			.catch((error) => console.error('Error', error))
			.finally(()=>{
				const _location = queryString.parse(localStorage.getItem('searchLocation')) || {};
				_location[_queryStr] = address;
				if (_latLng) {
					_location['lat'] = _latLng.lat;
					_location['lng'] = _latLng.lng;
				}
				localStorage.setItem('searchLocation', $.param(_location));
				localStorage.removeItem('useCurrentLocation');
			});
	};

	const searchOptions = {
		types: [],
		componentRestrictions: {
			country: !props.country ? 'au' : props.country,
			// country: 'au'
		},
	};

	const handleActiveInput = ((str) => {
		setActiveInput(str);
	});

	const clearInput = () => {
		setSearchTerm('');
		setCanClear(false);
	};

	const renderFunc = ({getInputProps, getSuggestionItemProps, suggestions}) => {
		// console.log(suggestions);
		// if(suggestions.length > 0) {
		// 	setPrevSuggestions(suggestions)
		// } else {
		// 	setPrevSuggestions([])
		// }
		setPrevSuggestions(suggestions);


		return (
			<div className="autocomplete-root" onClick={handleActiveInput}>
				<div className="search-container position-relative filterInput" >
					<div className="custom-search text-torch-red"></div>
					<input
						{...getInputProps({
							placeholder: 'Find an address, venue, or city',
							className: 'location-search-input p-2',
						})}/>
					{canClear && (<div className="icon-close" onClick={clearInput}></div>)}
				</div>
				<div className={`autocomplete-dropdown-container bg-white ${(suggestions.length > 0) ? 'show-border' : ''}`}>
					{suggestions.map((suggestion, i) => (
					<div className="suggestion" {...getSuggestionItemProps(suggestion)} key={i}>
						<span className="location-icon"></span>
						<div className="suggestion-text">
							<strong>{suggestion.formattedSuggestion.mainText}</strong>
							<span>, {suggestion.formattedSuggestion.secondaryText}</span>
						</div>
					</div>
					))}
					{suggestions.length > 0 &&
					<div className="suggestion near-location">
						<span className="near-location-icon"></span>
						<div className="suggestion-text">
							Search near my location
						</div>
					</div>
					}
				</div>
			</div>
		);
	};

	const onChange = (address) => {
		if(address) setCanClear(true);
		setSearchTerm(address);
	};

	return (
		<div>
				<PlacesAutocomplete
					value={searchTerm}
					onChange={onChange}
					onSelect={onSelect}
					searchOptions={searchOptions}
					highlightFirstSuggestion={true}
					shouldFetchSuggestions={searchTerm.length >= 2}
					>
					{renderFunc}
				</PlacesAutocomplete>
		</div>
	);
};

export default AddressSearchBar;
